import {AppResourceCollection} from '@milestoneslabs/milestones-js-engine';
import Vue from './../../../vue';

export default {
    SET_CURRENT_WORKSPACE(state, workspace) {
        state.currentWorkspace = workspace;
    },

    SET_ARE_CHANNELS_LOADED(state, areChannelsLoaded) {
        state.areChannelsLoaded = areChannelsLoaded;
    },

    SET_CURRENT_WORKSPACE_CHANNELS(state, channels) {
        state.currentWorkspaceChannels = channels;
    },

    ADD_CHANNEL_TO_EXISTING_CHANNELS(state, channel) {
        state.currentWorkspaceChannels.push(channel);
    },

    ADD_MESSAGE_TO_CHANNEL(state, {message, channelUuid}) {
        const channel = state.currentWorkspaceChannels.getResource(channelUuid);

        if ((channel.get('messages').length === 0) && (Array.isArray(channel.get('messages')))) {
            channel.setAttribute('messages', new AppResourceCollection('message'));
        }

        channel.get('messages').push(message);

        Vue.set(state.currentWorkspaceChannels, channelUuid, channel);
    },

    SET_CURRENT_PROJECT_ORGANIZATION_MEMBER(state, projectOrganizationMember) {
        state.currentProjectOrganizationMember = projectOrganizationMember;
    },

    SET_CURRENT_PROJECT_STAGES(state, stagesCollection) {
        state.currentProjectStages = stagesCollection;
    },

    SET_DEFAULT_MLS_ABBREVIATION(state, abbreviation) {
        state.defaultMlsAbbreviation = abbreviation;
    },

    SET_DEFAULT_MAP_COORDINATES(state, coords) {
        state.defaultSwNeMapLocationCoordinates = coords;
    },

    SET_BUY_FILTER(state, filter) {
        state.buyFilter = filter;
    },
};
